
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class TownsGrid extends Serenity.EntityGrid<TownsRow, any> {
        protected getColumnsKey() { return TownsColumns.columnsKey; }
        protected getDialogType() { return TownsDialog; }
        protected getIdProperty() { return TownsRow.idProperty; }
        protected getInsertPermission() { return TownsRow.insertPermission; }
        protected getLocalTextPrefix() { return TownsRow.localTextPrefix; }
        protected getService() { return TownsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}